import { IOrderShipped } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersShipped: IOrderShipped[] = [
  {
    userRole: 'EVA',
    erpId: 'some-erp-id-23920000',
    id: 'first-shipped-order',
    sender: 'SOME_SENDER',
    priority: 'HIGH',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.now,
    customerId: 'customer-0',
    customerPretty: 'Customer Name Pretty',
    status: 'SHIPPED',
    history: [
      {
        shippingStatus: 'LABEL_CREATED',
        shippingStatusPretty: { de: 'Label erstellt', en: 'Label created' },
        startedAt: 1717036800,
        location: 'Hannover',
      },
      {
        shippingStatus: 'IN_TRANSIT',
        shippingStatusPretty: { de: 'Auf dem Transportweg', en: 'In transit' },
        startedAt: 1717213200,
        location: 'Kassel',
        notes: { en: 'Some english Notes that René might have added', de: 'Ein paar deutsche Bemerkungen von René' },
      },
      {
        shippingStatus: 'OUT_FOR_DELIVERY',
        shippingStatusPretty: { de: 'Wird ausgeliefert', en: 'Out for delivery' },
        startedAt: 1717382400,
        location: 'Wien',
      },
      {
        shippingStatus: 'FAILED_ATTEMPT',
        shippingStatusPretty: { de: 'Zustellversuch gescheitert', en: 'Failed attempt' },
        startedAt: 1717387400,
        location: 'Wien',
      },
      {
        shippingStatus: 'OUT_FOR_DELIVERY',
        shippingStatusPretty: { de: 'Wird ausgeliefert', en: 'Out for delivery' },
        startedAt: 1717554000,
        location: 'Wien',
      },
    ],
    trackingId: 'ABC123456789',
    trackingLink: { de: 'https://post.at?id=ABC998877665544', en: 'https://post.at?id=ABC998877665544&lang=en' },
    trackingProvider: 'POST',
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
  {
    userRole: 'EVA',
    erpId: 'some-erp-id-1441414',
    id: 'second-shipped-order',
    sender: 'SOME_SENDER',
    priority: 'LOW',
    createdBy: 'BERNHARD',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.now,
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'SHIPPED',
    history: [
      {
        shippingStatus: 'IN_TRANSIT',
        shippingStatusPretty: { de: 'Auf dem Transportweg', en: 'In transit' },
        startedAt: 123456,
        location: 'Berlin',
      },
    ],
    trackingId: 'ABC998877665544',
    trackingLink: { de: 'https://post.at?id=ABC998877665544' },
    trackingProvider: 'POST',
    positions: [{ positionId: 'palette-800-100', amount: 17 }],
  },
  {
    userRole: 'EVA',
    erpId: 'some-erp-id-291291',
    id: 'third-shipped-order',
    sender: 'SOME_SENDER',
    priority: 'MID',
    createdBy: 'SAM',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'SAM',
    updatedAt: timestampMockHelpers.now,
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'SHIPPED',
    history: [
      {
        shippingStatus: 'OUT_FOR_DELIVERY',
        shippingStatusPretty: { de: 'Wird ausgeliefert', en: 'Out for delivery' },
        startedAt: 123456,
        location: 'Berlin',
      },
    ],
    trackingId: 'DDPP238749009',
    trackingLink: { en: 'https://post.at?id=DDPP238749009&lang=en' },
    trackingProvider: 'POST',
    positions: [{ positionId: 'palette-800-100', amount: 3 }],
  },
];
